import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ExistingStockItem } from '@features/stock/entity';

export type MaterialSearchResultsStoreStateType = {
  materialSearchResults: ExistingStockItem[];
  goodsSearchResults: ExistingStockItem[];
};

export const materialSearchResultsSlice = createSlice({
  initialState: {
    materialSearchResults: [],
    goodsSearchResults: [],
  } as MaterialSearchResultsStoreStateType,
  name: 'materialSearchResults',
  reducers: {
    setMaterialSearchResults: (state, action: PayloadAction<ExistingStockItem[]>) => {
      state.materialSearchResults = action.payload;
    },
    setGoodsSearchResults: (state, action: PayloadAction<ExistingStockItem[]>) => {
      state.goodsSearchResults = action.payload;
    },
  },
});

export const { setMaterialSearchResults, setGoodsSearchResults } =
  materialSearchResultsSlice.actions;

export default materialSearchResultsSlice.reducer;
